<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('xtgl')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('yhgl')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('gjz')">
                                    <el-input v-model="searchform.blurry" @keyup.enter.native="onSubmit" size="small" :placeholder="$t('ncdh')">
                                    </el-input>
                                </el-form-item>
                                <el-form-item v-if="searchform.groupId == null" :label="$t('role')">
                                    <el-select size="small" v-model="searchform.roleId" style="width:180px;" :placeholder="$t('qxzrole')"  >
                                        <el-option :label="$t('buxian')" :value="null"></el-option>
                                        <el-option v-for="(item,index) in rolelist" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="searchright">
                            <el-button size="small" type="primary" @click="openadd">+{{$t('adduser')}}</el-button>
                        </div>
                    </div>
                    <el-table :data="list"
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}"
                        stripe border style="width: 100%">
                        <el-table-column prop="username" :label="$t('dlm')"></el-table-column>
                        <el-table-column prop="nickName" :label="$t('nc')"></el-table-column>
                        <el-table-column prop="phone" :label="$t('phone')"></el-table-column>
                        <el-table-column prop="role" :label="$t('role')">
                            <template slot-scope="scope">
                                {{scope.row.roles[0].name}}
                            </template>
                        </el-table-column>
                        <el-table-column size="small" prop="groupName" :label="$t('gsxz')"></el-table-column>
                        <el-table-column prop="walkie" :label="$t('c22')"></el-table-column>
                        <el-table-column prop="inCall" :label="$t('c23')"></el-table-column>
                        <el-table-column prop="kmiCall" :label="$t('c25')"></el-table-column>
                        <el-table-column prop="aiCall" :label="$t('c26')"></el-table-column>
                        <el-table-column prop="callplatform" :label="$t('c24')"></el-table-column>
                        <el-table-column prop="roleDesc" :label="$t('status')" width="70">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.enabled" :disabled="scope.row.id === 1"
                                    active-color="#409EFF" inactive-color="#F56C6C"
                                    @change="changeEnabled(scope.row, scope.row.enabled,)" />
                            </template>
                        </el-table-column>
                        <el-table-column prop="level" :label="$t('zhdlsh')">
                            <template slot-scope="scope">
                                {{scope.row.updateTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="150">
                            <template slot-scope="scope">
                                <el-button v-if="user.user.id!=scope.row.id" size="small" @click="openedit(scope.row)" type="primary" icon="el-icon-edit"
                                    circle plain style="margin-right:5px;"></el-button>
                                <el-popconfirm :title="$t('isczmm')" @confirm="resetpass(scope.row)">
                                    <el-button size="small" type="primary" icon="el-icon-s-claim" circle plain
                                        slot="reference" style="margin-right:5px">
                                    </el-button>
                                </el-popconfirm>
                                <el-popconfirm :title="$t('tel83')" @confirm="deleteuser(scope.row)">
                                    <el-button size="small" type="warning" icon="el-icon-delete-solid" circle slot="reference" plain></el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
        <pop-up :title="status==1?$t('adduser'):$t('edituser')" width="30%" :isshow="showadd" :haveconfirm="true" @close="getclose"
            @confirm="getconfirm">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small" label-width="160px">
                    <el-form-item :label="$t('dlm')" prop="username">
                        <el-input v-model="form.username" :disabled="status==2?true:false" />
                    </el-form-item>
                    <el-form-item :label="$t('phone')" prop="phone">
                        <el-input v-model.number="form.phone" />
                    </el-form-item>
                    <el-form-item :label="$t('nc')" prop="nickName">
                        <el-input v-model="form.nickName"/>
                    </el-form-item>
                    <!-- <el-form-item :label="$t('gender')">
                        <el-radio-group v-model="form.gender" style="width: 178px">
                            <el-radio label="男">{{$t('nan')}}</el-radio>
                            <el-radio label="女">{{$t('nv')}}</el-radio>
                        </el-radio-group>
                    </el-form-item> -->
                    <el-form-item :label="$t('status')">
                        <el-radio-group v-model="form.enabled">
                            <el-radio label="true">{{$t('jihuo')}}</el-radio>
                            <el-radio label="false">{{$t('suoding')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('role')" >
                        <el-select v-model="form.roles[0].id" :placeholder="$t('qxzrole')">
                            <el-option v-for="item in rolelist" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="form.roles[0].id == 3" style="margin-top: 60;" :label="$t('group')" >
                        <el-select v-model="form.groupId" :placeholder="$t('qxzfz')">
                            <el-option v-for="item in grouplist" :key="item.id" :label="item.groupName" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="form.roles[0].id == 5" style="margin-top: 60;" :label="$t('tel82')" >
                        <el-select v-model="form.groupId" :placeholder="$t('qxzfz')">
                            <el-option v-for="item in grouplist1" :key="item.id" :label="item.groupName" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="form.roles[0].id == 3 || form.roles[0].id == 5" prop="walkie" style="margin-top: 60;" :label="$t('c22')" >
                        <el-input v-model="form.walkie"/>
                    </el-form-item>
                    <el-form-item v-if="form.roles[0].id == 3 || form.roles[0].id == 5" prop="inCall" style="margin-top: 60;" :label="$t('c23')" >
                        <el-input v-model="form.inCall"/>
                    </el-form-item>
                    <el-form-item v-if="form.roles[0].id == 3 || form.roles[0].id == 5" prop="kmiCall" style="margin-top: 60;" :label="$t('c25')" >
                        <el-input v-model="form.kmiCall"/>
                    </el-form-item>
                    <el-form-item v-if="form.roles[0].id == 3 || form.roles[0].id == 5" prop="aiCall" style="margin-top: 60;" :label="$t('c26')" >
                        <el-input v-model="form.aiCall"/>
                    </el-form-item>
                    <el-form-item v-if="form.roles[0].id == 3 || form.roles[0].id == 5" prop="callplatform" style="margin-top: 60;" :label="$t('c24')" >
                        <el-radio-group v-model="form.callplatform">
                            <el-radio label="NX">NX</el-radio>
                            <el-radio label="infin8linx">infin8linx</el-radio>
                            <el-radio label="KMI">KMI</el-radio>
                            <el-radio label="94AI">94AI</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/sys"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                if (value[0].id) {
                    callback()
                } else {
                    callback(new Error(this.$t('qxzrole')));
                }
            }
            return {
                options: [{
                    value: 'mx',
                    label: '墨西哥'
                    }, {
                    value: 'pe',
                    label: '秘鲁'
                    }],
                enabledTypeOptions: [{
                        key: 'true',
                        display_name: this.$t('jihuo')
                    },
                    {
                        key: 'false',
                        display_name: this.$t('suoding')
                    }
                ],
                form: {
                    id: null,
                    username: null,
                    nickName: null,
                    gender: '男',
                    enabled: true,
                    groupName:null,
                    roles: [{
                        id: null
                    }],
                    phone: null,
                    nation: null,
                    walkie: null,
                    groupId: null,
                    callplatform: null,
                    inCall: null,
                    kmiCall: null,
                    aiCall: null,
                },
                searchform: {
                    blurry: "",
                },
                loading: false,
                showadd: false,
                list: [],
                total: 1,
                pageNo: 1,
                pageSize: 10,
                keyword: '',
                user:null,
                roleId:null,
                rolelist: [],
                groupId:null,
                grouplist:[],
                grouplist1:[],
                status: 1,
                rules: {
                    username: [{
                            required: true,
                            message: this.$t('qsryhm'),
                            trigger: 'blur'
                        },
                        {
                            min: 2,
                            max: 20,
                            message: '长度在 2 到 20 个字符',
                            trigger: 'blur'
                        }
                    ],
                    nickName: [{
                            required: true,
                            message: this.$t('qsryhnc'),
                            trigger: 'blur'
                        },
                        {
                            min: 2,
                            max: 20,
                            message: '长度在 2 到 20 个字符',
                            trigger: 'blur'
                        }
                    ],
                    email: [{
                            required: true,
                            message: this.$t('qsryxdz'),
                            trigger: 'blur'
                        },
                        {
                            type: 'email',
                            message: this.$t('qsrzqyxdz'),
                            trigger: 'blur'
                        }
                    ],
                    phone: [{
                        required: true,
                        message: this.$t('qsrsjh'),
                        trigger: 'blur'
                    }],
                    roles: [{
                        required: true,
                        validator: rolesValid,
                        trigger: 'change'
                    }],
                }
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.searchform.roleId = this.$route.query.roleId
            this.searchform.groupId = this.$route.query.groupId
            this.getList()
            this.getrole()
            this.getgrouplist()
            this.getgrouplist1()
        },
        methods: {
            resetpass(row) {
                _api.post(apiurl.resetPass, {
                    userId: row.id
                }).then(res => {
                    if (res) {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('czcg')
                        })
                    } else {
                        this.$notify.error({
                            title: this.$t('shibai'),
                            message: this.$t('czsb')
                        })
                    }
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    });
                })
            },
            deleteuser(row) {
                _api.delete(apiurl.users, row.id).then(res => {
                    this.$notify({
                        title: this.$t('success'),
                        message: this.$t('delSuccess'),
                        type: 'success'
                    });
                    this.pageNo = 1
                    this.getList()
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    });
                })
            },
            openadd() {
                this.showadd = true
                this.status = 1
                this.form = {
                    id: null,
                    username: null,
                    nickName: null,
                    gender: '男',
                    email: null,
                    enabled: true,
                    roles: [{
                        id: null
                    }],
                    groupId:null,
                    phone: null,
                    walkie: null,
                    callplatform: null,
                    inCall: null,
                    kmiCall: null,
                    aiCall: null,
                    nation: localStorage.getItem("nation")
                }
            },
            openedit(row) {
                console.log(row)
                this.status = 2
                this.form.id = row.id
                this.form.username = row.username
                this.form.nickName = row.nickName
                this.form.gender = row.gender
                this.form.enabled = row.enabled
                this.form.phone = row.phone
                this.form.roles[0].id = row.roles[0].id
                this.form.groupId = row.groupId,
                this.form.nation = row.nation,
                this.form.walkie = row.walkie,
                this.form.callplatform = row.callplatform,
                this.form.inCall = row.inCall,
                this.form.kmiCall = row.kmiCall,
                this.form.aiCall = row.aiCall,
                this.showadd = true
            },
            changeEnabled(data, val) {
                this.$confirm('确认要执行操作吗, 是否继续？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.status = 2
                    this.form.id = data.id
                    this.form.username = data.username
                    this.form.nickName = data.nickName
                    this.form.gender = data.gender
                    this.form.enabled = val
                    this.form.phone = data.phone
                    this.form.roles[0].id = data.roles[0].id
                    this.form.groupName = data.groupName,
                    this.form.groupId = data.groupId,
                    this.form.nation= row.nation,
                    this.form.walkie = row.walkie,
                    this.form.inCall = row.inCall,
                    this.form.kmiCall = row.kmiCall,
                    this.form.aiCall = row.aiCall,
                    this.form.callplatform = row.callplatform,
                    _api.put(apiurl.users, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('czcg')
                        })
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            username: null,
                            nickName: null,
                            gender: '男',
                            enabled: true,
                            roles: [{
                                id: null
                            }],
                            groupId:null,
                            phone: null,
                            walkie: null,
                            nation: null,
                            inCall: null,
                            kmiCall: null,
                            aiCall: null,
                            callplatform: null,
                        }

                    }).catch(err => {
                        this.$notify.error({
                            title:this.$t('error'),
                            message: err.data.message
                        })
                    })
                }).catch(() => {
                    data.enabled = !data.enabled
                })
            },
            getList() {
                this.loading = true
                _api.get(apiurl.users, {
                    page: this.pageNo,
                    size: this.pageSize,
                    blurry: this.searchform.blurry,
                    roleId: this.searchform.roleId,
                    nation:localStorage.getItem("nation"),
                    groupId: this.searchform.groupId,
                }).then(res => {
                    this.loading = false
                    this.list = res.content
                    this.total = res.totalElements
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            getrole() {
                _api.get(apiurl.roles, {}).then(res => {
                    let newarr=[]
                    for(let item of res.content){
                        newarr.push(item)
                    }
                    this.rolelist = newarr
                })
            },
            getgrouplist(){
                _api.get(apiurl.group, {
                    nation:localStorage.getItem("nation")
                }).then(res => {
                    this.grouplist = res.data
                })
            },
            getgrouplist1(){
                _api.get(apiurl.telGroup, {
                    nation:localStorage.getItem("nation")
                }).then(res => {
                    this.grouplist1 = res.data
                })
            },
            getconfirm() {
                if(this.form.roles[0].id==null || this.form.roles[0].id==""){
                    this.$message.error(this.$t('qxzrole'))
                    return
                }
                
                if (this.status == 1) { //如果是添加
                    _api.post(apiurl.users, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('addSuccess')
                        })
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            username: null,
                            nickName: null,
                            gender: '男',
                            enabled: true,
                            roles: [{
                                id: null
                            }],
                            phone: null,
                            walkie: null,
                            inCall: null,
                            kmiCall: null,
                            aiCall: null,
                            callplatform:null,
                            nation: null,
                            groupId: null,
                        }

                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                } else { //如果是编辑
                    _api.put(apiurl.users, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('editSuccess')
                        })
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            username: null,
                            nickName: null,
                            gender: '男',
                            enabled: true,
                            roles: [{
                                id: null
                            }],
                            groupId:null,
                            phone: null,
                            walkie: null,
                            inCall: null,
                            kmiCall: null,
                            aiCall: null,
                            callplatform:null,
                            nation: null,
                        }
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                }
                  
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            loadNode(node, resolve) {
                if (node.level === 0) {
                    return resolve(this.depts);
                }
                //if (node.level > 1) return resolve([]);
                _api.get(apiurl.dept, {
                    enabled: true,
                    pid: node.data.id
                }).then(res => {
                    // console.log(res)
                    var zsarr = res.content
                    for (let item of zsarr) {
                        item.isLeaf = !item.hasChildren
                    }
                    resolve(zsarr)
                })
            },
            handleNodeClick(mydata, node, obj) {
                this.searchform.blurry = ""
                this.loading = true
                this.pageNo=1
                this.getList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                console.log(data)
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>